import { Textarea } from '@/components/ui/textarea'
import { cn } from '@/lib/utils'
import { ChangeEvent, ComponentProps, PropsWithChildren, useEffect, useRef, useState } from 'react'

type ViverseTextareaProps = PropsWithChildren<ComponentProps<typeof Textarea>> & {
  showMaxLength?: boolean
  containerClassName?: string
}

function ViverseTextarea({
  className,
  children,
  maxLength,
  showMaxLength = true,
  onChange,
  containerClassName,
  ...props
}: ViverseTextareaProps) {
  const [valueLength, setValueLengh] = useState(0)
  const defaultValue = useRef(typeof props.value === 'string' ? props.value : '')

  useEffect(() => {
    if (defaultValue.current) {
      setValueLengh(defaultValue.current.length)
    }
  }, [])

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange?.(e)
    setValueLengh(e.target.value.length)
  }

  return (
    <div className="box-border flex items-center">
      <div
        className={cn(
          'bg-vive-popup border-vive-primary-70 focus-within:border-vive-border-focus! hover:border-vive-brand-50 flex flex-1 items-center rounded-md border-2 transition-all duration-300',
          containerClassName,
        )}
      >
        <Textarea
          className={cn('bg-vive-popup resize-none rounded-sm border-none text-white', className)}
          onChange={handleChange}
          maxLength={maxLength}
          {...props}
        >
          {children}
        </Textarea>
        {showMaxLength && (
          <div className="h-full w-max px-3 py-1 text-nowrap">
            <span className="caption text-vive-primary-40">
              {valueLength} / {maxLength}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}

export default ViverseTextarea
